import { render, staticRenderFns } from "./FloatInputBox.vue?vue&type=template&id=2e324169&"
import script from "./FloatInputBox.vue?vue&type=script&lang=js&"
export * from "./FloatInputBox.vue?vue&type=script&lang=js&"
import style0 from "./FloatInputBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FloatInputBox.vue"
export default component.exports